import React, { Component } from "react";
import { Card, Accordion } from "react-bootstrap";
import "../../css/Dashboard.css";

class Transactions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      transactions: []
    };
  }

  componentDidMount() {
    const token = localStorage.getItem("token");

    if (!token) {
      console.error("No auth token found.");
      return;
    }

    fetch("https://d1dgpoid6t01jm.cloudfront.net/user/user-transaction", {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then(async response => {
        if (!response.ok) {
          const err = await response.text();
          throw new Error(err || "Failed to fetch transactions");
        }
        return response.json();
      })
      .then(data => {
        const rows = data?.response?.rows || [];
        this.setState({ transactions: rows });
      })
      .catch(err => {
        console.error("Transaction fetch error:", err.message);
      });
  }

  render() {
    const { transactions } = this.state;

    return (
      <div>
        <div className="gym-background background-watermark">
          <div className="container-fluid">
            <div className="row">
              <div className="col-sm-10">
                <h3 className="shady_header">Transactions</h3>

                <Accordion defaultActiveKey="0">
                  {transactions.length > 0 ? (
                    transactions.map((item, i) => (
                      <div
                        key={i}
                        className="enroll-now-container border_design"
                      >
                        <div style={{ width: "100%" }}>
                          <Accordion.Toggle
                            as={Card.Header}
                            eventKey={i.toString()}
                            className="cardheader"
                          >
                            <div className="container-row-service">
                              <span>Order ID: {item.order_id}</span>
                              <span>
                                <span className="dottinproductinfo_toggle">
                                  <i className="fa fa-chevron-down"></i>
                                </span>
                              </span>
                            </div>
                          </Accordion.Toggle>
                          <Accordion.Collapse eventKey={i.toString()}>
                            <Card.Body>
                              <div>Amount - ₹{item.amount}</div>
                              <div>Status - {item.status}</div>
                              <div>Created At - {new Date(item.created_at).toLocaleString()}</div>
                              {item.service_booking && (
                                <>
                                  <div>Booking Name - {item.service_booking.booking_name}</div>
                                  <div>Trial Date - {item.service_booking.trial_date}</div>
                                  <div>Trial Time - {item.service_booking.trial_time}</div>
                                </>
                              )}
                            </Card.Body>
                          </Accordion.Collapse>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p style={{ color: "white", marginTop: "1rem" }}>
                      No transactions available.
                    </p>
                  )}
                </Accordion>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Transactions;
